import React, { useState, useEffect, useContext, useRef } from 'react'
import { ThemeContext } from '../context/ThemeContext'
import '../styles/SignIn.css'
import { useNavigate } from 'react-router-dom'
import vestrLogo1light from '../assets/logo1light.svg'
import vestrLogo1dark from '../assets/vestrLogoUpdated.svg'
import config from '../config'
import { AuthContext } from '../context/AuthContext'

const slides = [
  {
    title: 'Vestr is the finance super app -',
    subtitle: 'combining trading, social, news, and research',
  },
  {
    title: '1/ Simulate trading stocks, options, crypto and forex.',
    subtitle: 'Test strategies with multiple portfolios',
  },
  {
    title: '2/ Follow your friends and top investors',
    subtitle: 'to see who is the best (and worst)',
  },
  {
    title: '3/ Join groups',
    subtitle: 'to compete in an organization or team',
  },
  {
    title: '4/ Research financial assets with Mr. Vestr,',
    subtitle: 'our AI tool',
  },
  {
    title: '5/ Read your Vestr newspaper',
    subtitle: 'to stay on top of market updates',
  },
]

const animalAvatars = [
  '/Avatars/animalAvatar1.svg',
  '/Avatars/animalAvatar2.svg',
  '/Avatars/animalAvatar3.svg',
  '/Avatars/animalAvatar4.svg',
  '/Avatars/animalAvatar5.svg',
  '/Avatars/animalAvatar6.svg',
  '/Avatars/animalAvatar7.svg',
  '/Avatars/animalAvatar8.svg',
]
const peopleAvatars = [
  '/Avatars/personAvatar1.svg',
  '/Avatars/personAvatar2.svg',
  '/Avatars/personAvatar3.svg',
  '/Avatars/personAvatar4.svg',
  '/Avatars/personAvatar5.svg',
  '/Avatars/personAvatar6.svg',
  '/Avatars/personAvatar7.svg',
  '/Avatars/personAvatar8.svg',
]

export default function SignIn() {
  const navigate = useNavigate()
  const { dk } = useContext(ThemeContext)
  const { signIn } = useContext(AuthContext)
  const { userToken, userId } = useContext(AuthContext)

  const [mode, setMode] = useState('intro')
  const [currentSlide, setCurrentSlide] = useState(0)

  // sign in fields
  const [inputValue, setInputValue] = useState('') // unified field for phone or username
  const [isPhoneValid, setIsPhoneValid] = useState(false)
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [isAuthenticating, setIsAuthenticating] = useState(false)

  const [signup, setSignup] = useState({ email: '', password: '', confirm: '' })
  const [resetPin, setResetPin] = useState({ password: '', confirm: '' })

  const [step, setStep] = useState(1)
  const [name, setName] = useState('')
  const [username, setUsername] = useState('')
  const [usernameStatus, setUsernameStatus] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [otp, setOtp] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [profilePicture, setProfilePicture] = useState(null)
  const [loading, setLoading] = useState(false)
  const [emailOtpToken, setEmailOtpToken] = useState('')
  const [user, setUser] = useState(null)
  const [resetStep, setResetStep] = useState(1)
  const [resetEmail, setResetEmail] = useState('')
  const [resetOtp, setResetOtp] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [selected, setSelected] = useState('email')
  const [otpBoxes, setOtpBoxes] = useState(['', '', '', '', '', ''])
  const [selectedProfilePicture, setSelectedProfilePicture] = useState(
    animalAvatars[0]
  )
  const [backgroundColor, setBackgroundColor] = useState('#000000') // default black
  const [colorSliderValue, setColorSliderValue] = useState(0)
  const [resendCooldown, setResendCooldown] = useState(0)
  const [otpMethod, setOtpMethod] = useState('email') // 'email' or 'phone'
  const resendTimerRef = useRef(null)

  const handleColorSlider = (e) => {
    const val = e.target.value
    setColorSliderValue(val)

    // Map slider 0-100 to hue 0-360
    const hue = (val / 100) * 360
    setBackgroundColor(`hsl(${hue}, 100%, 50%)`)
  }

  const otpRefs = useRef([])

  const handleOtpChange = (e, idx) => {
    const val = e.target.value.replace(/\D/g, '')
    if (!val) return
    const updated = [...otpBoxes]
    updated[idx] = val[0]
    setOtpBoxes(updated)
    if (idx < 5) otpRefs.current[idx + 1]?.focus()
  }

  const handleOtpBackspace = (e, index) => {
    if (e.key === 'Backspace') {
      const updated = [...otpBoxes]

      if (otpBoxes[index]) {
        // Clear current box if it has a value
        updated[index] = ''
        setOtpBoxes(updated)
      } else if (index > 0) {
        // Otherwise go back and clear previous box
        updated[index - 1] = ''
        setOtpBoxes(updated)
        otpRefs.current[index - 1]?.focus()
      }
    }
  }

  const [accounts, setAccounts] = useState([
    {
      id: 1,
      name: 'Roaring Kitty',
      handle: 'roaringkitty',
      return: 54.55,
      desc: 'Professor of macroeconomics at Clemson University and a long term investor in UCO and BTC.',
      verified: true,
      avatar: 'https://placehold.co/40',
      following: false,
    },
  ])
  const [groups, setGroups] = useState([
    {
      id: 1,
      name: 'Clemson',
      members: '22,345',
      desc: 'Professor of macroeconomics at Clemson University and a long term investor in UCO and BTC.',
      verified: true,
      avatar: 'https://placehold.co/40',
      joined: false,
    },
  ])
  const [watchlist, setWatchlist] = useState([
    {
      id: 1,
      symbol: 'HOOD',
      company: 'Robinhood Markets LLC',
      price: 111.42,
      change: 1.65,
      added: false,
    },
  ])

  useEffect(() => {
    if (mode === 'intro') {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length)
      }, 3000)
      return () => clearInterval(interval)
    }
  }, [mode])

  useEffect(() => {
    if (resendCooldown > 0) {
      resendTimerRef.current = setTimeout(() => {
        setResendCooldown(resendCooldown - 1)
      }, 1000)
    }
    return () => clearTimeout(resendTimerRef.current)
  }, [resendCooldown])

  // Step 1: verify user existence
  const handleNextSignInStep = async (e) => {
    e.preventDefault()
    setLoginError('')
    setIsAuthenticating(true)
    try {
      const cleanedPhone = inputValue.replace(/\D/g, '')
      const body =
        /^\d+$/.test(cleanedPhone) && cleanedPhone.length >= 6
          ? { phone: cleanedPhone }
          : { username: inputValue.trim() }

      const res = await fetch(`${config.backendUrl}/api/auth/signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })

      if (res.ok) {
        setMode('signin-step2')
      } else {
        const msg = await res.text()
        setLoginError(msg || 'User not found')
      }
    } catch (err) {
      console.error(err)
      setLoginError('Error checking user')
    } finally {
      setIsAuthenticating(false)
    }
  }

  // Step 2: verify password
  const handleSignIn = async (e) => {
    e.preventDefault()
    setPasswordError('')
    try {
      const cleanedPhone = inputValue.replace(/\D/g, '')
      const body =
        /^\d+$/.test(cleanedPhone) && cleanedPhone.length >= 6
          ? { phone: cleanedPhone, password }
          : { username: inputValue.trim(), password }

      const res = await fetch(`${config.backendUrl}/api/auth/verify-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })

      if (!res.ok) {
        const msg = await res.text()
        setPasswordError(msg || 'Incorrect password')
        return
      }

      const data = await res.json()
      localStorage.setItem('authUser', JSON.stringify(data.user))
      signIn(data.user)
      navigate('/')
    } catch (err) {
      console.error(err)
      setPasswordError('Login failed')
    }
  }

  const checkUsername = async () => {
    if (!username.trim()) return
    setLoading(true)
    try {
      const res = await fetch(
        `${config.backendUrl}/api/auth/check-username-exist`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username }),
        }
      )
      const data = await res.json()
      if (res.ok && data.status === 1) {
        setUsernameStatus('available')
      } else {
        setUsernameStatus(data.message || 'taken')
      }
    } catch (e) {
      setUsernameStatus('error')
    } finally {
      setLoading(false)
    }
  }

  const handleIdentifierChange = (val) => {
    const digitsOnly = val.replace(/\D/g, '')
    if (/^\d+$/.test(digitsOnly) && val.length > 0) {
      let cleaned = digitsOnly.slice(0, 10)
      let formatted = cleaned
      if (cleaned.length > 6) {
        formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(
          3,
          6
        )}-${cleaned.slice(6)}`
      } else if (cleaned.length > 3) {
        formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`
      } else if (cleaned.length > 0) {
        formatted = `(${cleaned}`
      }
      setInputValue(formatted)
      setIsPhoneValid(cleaned.length === 10)
      setPhone(formatted)
    } else {
      setInputValue(val)
      setIsPhoneValid(false)
    }
    setLoginError('')
  }

  const toggleFollow = (id) =>
    setAccounts((prev) =>
      prev.map((a) => (a.id === id ? { ...a, following: !a.following } : a))
    )
  const toggleJoin = (id) =>
    setGroups((prev) =>
      prev.map((g) => (g.id === id ? { ...g, joined: !g.joined } : g))
    )
  const toggleWatch = (id) =>
    setWatchlist((prev) =>
      prev.map((w) => (w.id === id ? { ...w, added: !w.added } : w))
    )

  const isValidPassword = (p) =>
    p.length >= 6 && /[A-Z]/.test(p) && /\d/.test(p)

  const handleNextOnboarding = () => {
    if (mode === 'onboarding1') setMode('onboarding2')
    else if (mode === 'onboarding2') setMode('onboarding3')
    else if (mode === 'onboarding3') navigate('/home')
  }

  const Stepper = () => (
    <div className="stepper-bar">
      <div className={`step ${step >= 1 ? 'active' : ''}`}></div>
      <div className={`step ${step >= 2 ? 'active' : ''}`}></div>
      <div className={`step ${step >= 3 ? 'active' : ''}`}></div>
      <div className={`step ${step >= 4 ? 'active' : ''}`}></div>
      <div className={`step ${step >= 5 ? 'active' : ''}`}></div>
    </div>
  )

  const base64ToBlob = (base64Data, contentType = 'image/png') => {
    const byteCharacters = atob(base64Data.split(',')[1])
    const byteArrays = []

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512)
      const byteNumbers = new Array(slice.length)
      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j)
      }
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, { type: contentType })
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml']
    if (!validTypes.includes(file.type)) {
      alert('Only PNG, JPG, JPEG, or SVG images are allowed')
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => {
      setSelectedProfilePicture(reader.result)
    }
    reader.readAsDataURL(file)
  }

  const handleFinish = async () => {
    if (!selectedProfilePicture) return
    const formData = new FormData()

    if (selectedProfilePicture.startsWith('data:image')) {
      const blob = base64ToBlob(selectedProfilePicture)
      const file = new File([blob], 'profile.png', { type: 'image/png' })
      formData.append('profilePicture', file)
    } else {
      // For preset avatars, extract extension from the file path
      const urlParts = selectedProfilePicture.split('.')
      const extension = urlParts[urlParts.length - 1] || 'svg'
      
      const response = await fetch(selectedProfilePicture)
      const blob = await response.blob()
      const file = new File([blob], `preset.${extension}`, { type: blob.type })
      formData.append('profilePicture', file)
    }
    const authUser = JSON.parse(localStorage.getItem('authUser'))
    const token = authUser?.token
    formData.append('email', email)

    try {
      const res = await fetch(
        `${config.backendUrl}/api/auth/upload-profile-picture`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      )

      const data = await res.json()
      if (res.ok) {
        console.log('Uploaded:', data.profilePicture)
        signIn(authUser)
        navigate('/')
      } else {
        alert(data.message || 'Failed to upload profile picture')
      }
    } catch (err) {
      console.error('Upload error:', err)
      alert('Upload failed. Please try again.')
    }
  }

  return (
    <div className="signin-wrapper">
      {mode === 'intro' && (
        <div className="onboarding">
          <div className="onboarding-text-block">
            <h2 className="onboarding-title">
              {slides[currentSlide].title}{' '}
              <span className="onboarding-subtitle">
                {slides[currentSlide].subtitle}
              </span>
            </h2>
          </div>
          <div className="onboarding-dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`dot ${i === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(i)}
              />
            ))}
          </div>
          <div className="onboarding-buttons">
            <button
              className="btn-outline"
              onClick={() => setMode('signin-step1')}
            >
              Sign in
            </button>
            <button
              className="btn-primary"
              onClick={() => setMode('signup-step1')}
            >
              Create account
            </button>
          </div>
        </div>
      )}
      {mode === 'signin-step1' && (
        <form className="auth-card" onSubmit={handleNextSignInStep}>
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>

          <h2>First, enter your phone number or username</h2>
          <input
            placeholder="Phone number or username"
            value={inputValue}
            onChange={(e) => handleIdentifierChange(e.target.value)}
            style={{
              color: isPhoneValid ? '#00ff00' : '#fff',
            }}
          />
          {loginError && (
            <div style={{ color: 'red', marginTop: '8px' }}>{loginError}</div>
          )}

          <a className="link" onClick={() => setMode('forgot-step1')}>
            Forgot password?
          </a>

          <button
            className="primary"
            type="submit"
            disabled={isAuthenticating || inputValue.trim().length === 0}
          >
            {isAuthenticating ? 'Checking...' : 'Next'}
          </button>
        </form>
      )}
      {mode === 'signin-step2' && (
        <form className="auth-card" onSubmit={handleSignIn}>
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>

          <h2>Enter your password</h2>
          <div className="phone-display">{inputValue}</div>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              setPasswordError('')
            }}
          />
          {passwordError && (
            <div style={{ color: 'red', marginTop: '8px' }}>
              {passwordError}
            </div>
          )}

          <a className="link" onClick={() => setMode('forgot-step1')}>
            Forgot password?
          </a>

          <button className="primary" type="submit">
            Sign in
          </button>
        </form>
      )}
      {mode.startsWith('signup') && (
        <div className="auth-card">
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img src={dk() ? vestrLogo1dark : vestrLogo1light} alt="logo" />
            </div>
          </div>
          <Stepper />

          {/* Step 1: Enter name and username */}
          {mode === 'signup-step1' && (
            <form
              onSubmit={async (e) => {
                e.preventDefault()
                if (!name.trim() || !username.trim()) return
                setLoading(true)
                try {
                  const res = await fetch(
                    `${config.backendUrl}/api/auth/check-username-exist`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ username }),
                    }
                  )
                  const data = await res.json()
                  if (res.ok && data.status === 1) {
                    setUsernameStatus('available')
                    setMode('signup-step2')
                  } else {
                    setUsernameStatus(data.message || 'taken')
                  }
                } catch (err) {
                  console.error(err)
                  setUsernameStatus('error')
                } finally {
                  setLoading(false)
                }
              }}
            >
              {/* Top progress bar */}
              <div className="stepper-progress-bar">
                <div className="stepper-fill" style={{ width: '25%' }}></div>
              </div>

              <h2 className="onboarding-title">Create your account</h2>
              <p className="onboarding-subtitle">
                Your username is unique to you. You can change this information
                anytime in settings.
              </p>

              <input
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                placeholder="Username"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value)
                  setUsernameStatus('')
                }}
                onBlur={checkUsername}
              />
              {usernameStatus && usernameStatus !== 'available' && (
                <div className="error">{usernameStatus}</div>
              )}

              <button
                type="submit"
                className="primary"
                disabled={
                  loading ||
                  !name.trim() ||
                  !username.trim() ||
                  usernameStatus !== 'available'
                }
              >
                {loading ? 'Checking...' : 'Next'}
              </button>
            </form>
          )}

          {/* Step 2: Enter email and phone number */}
          {mode === 'signup-step2' && (
            <form
              onSubmit={async (e) => {
                e.preventDefault()
                if (!phone.trim() || !email.trim()) return
                setLoading(true)
                try {
                  const cleanedPhone = phone.replace(/\D/g, '')
                  const identifier =
                    /^\d+$/.test(cleanedPhone) && cleanedPhone.length >= 6
                      ? cleanedPhone
                      : inputValue.trim()
                  // Step 1: Validate with /signup
                  const signupRes = await fetch(
                    `${config.backendUrl}/api/auth/signup`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        name,
                        username,
                        phone: identifier,
                        email,
                      }),
                    }
                  )

                  if (!signupRes.ok) {
                    const errorText = await signupRes.text()
                    console.error(errorText)
                    alert(errorText || 'Signup validation failed')
                    setLoading(false)
                    return
                  }

                  // Step 2: Request OTP
                  const otpRes = await fetch(
                    `${config.backendUrl}/api/auth/request-otp`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ email }),
                    }
                  )

                  const otpData = await otpRes.json()
                  if (otpData.status === 1) {
                    setEmailOtpToken(otpData.data.token)
                    setMode('signup-step3')
                  } else {
                    alert(otpData.message || 'Failed to send OTP')
                  }
                } catch (err) {
                  console.error(err)
                  alert('Something went wrong')
                } finally {
                  setLoading(false)
                }
              }}
            >
              {/* Progress bar */}
              <div className="stepper-progress-bar">
                <div className="stepper-fill" style={{ width: '50%' }}></div>
              </div>

              <h2 className="onboarding-title">You need a way to sign in</h2>
              <p className="onboarding-subtitle">
                Adding a phone number also allows us to authenticate a user’s
                humanity.
              </p>
              <input
                placeholder="Phone Number"
                value={inputValue}
                onChange={(e) => handleIdentifierChange(e.target.value)}
                style={{
                  color: isPhoneValid ? '#00ff00' : '#fff',
                }}
              />
              <input
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <button type="submit" className="primary">
                {loading ? 'Submitting...' : 'Next'}
              </button>
            </form>
          )}

          {/* Step 3: Verify OTP */}
          {mode === 'signup-step3' && (
            <form
              onSubmit={async (e) => {
                e.preventDefault()
                const enteredOtp = otpBoxes.join('')
                if (enteredOtp.length !== 6) return
                setLoading(true)
                try {
                  const res = await fetch(
                    `${config.backendUrl}/api/auth/verify-otp-signup`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ email, otp: enteredOtp }),
                    }
                  )
                  const data = await res.json()
                  if (res.ok && data.status === 1) {
                    setMode('signup-step4')
                  } else {
                    alert(data.message || 'Invalid OTP')
                  }
                } catch (err) {
                  console.error(err)
                  alert('Something went wrong')
                } finally {
                  setLoading(false)
                }
              }}
            >
              <div className="stepper-progress-bar">
                <div className="stepper-fill" style={{ width: '75%' }}></div>
              </div>

              <h2 className="onboarding-title">We texted you a code</h2>
              <p className="onboarding-subtitle">
                Enter it below to verify {email || '(your email)'}
              </p>

              <div className="otp-box-wrapper">
                {otpBoxes.map((digit, idx) => (
                  <input
                    key={idx}
                    ref={(el) => (otpRefs.current[idx] = el)}
                    type="text"
                    maxLength={1}
                    inputMode="numeric"
                    className="otp-box"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, idx)}
                    onKeyDown={(e) => handleOtpBackspace(e, idx)}
                  />
                ))}
              </div>
              <div className="resend-note">
                Didn’t receive a code?{' '}
                <span
                  className={`link ${resendCooldown > 0 ? 'disabled' : ''}`}
                  style={{
                    cursor: resendCooldown > 0 ? 'not-allowed' : 'pointer',
                    color: resendCooldown > 0 ? '#888' : '#06ff38',
                    textDecoration: resendCooldown > 0 ? 'none' : 'underline',
                  }}
                  onClick={async () => {
                    if (resendCooldown > 0 || !email) return

                    setLoading(true)
                    try {
                      const res = await fetch(
                        `${config.backendUrl}/api/auth/request-otp`,
                        {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ email }),
                        }
                      )
                      const data = await res.json()
                      if (data.status === 1) {
                        setEmailOtpToken(data.data.token)
                        setResendCooldown(30) // Start cooldown
                        alert('OTP has been resent to your email.')
                      } else {
                        alert(data.message || 'Failed to resend OTP')
                      }
                    } catch (err) {
                      console.error('Resend OTP failed:', err)
                      alert('Something went wrong. Try again.')
                    } finally {
                      setLoading(false)
                    }
                  }}
                >
                  {resendCooldown > 0
                    ? `Resend OTP in ${resendCooldown}s`
                    : 'Resend OTP'}
                </span>
              </div>

              <button type="submit" className="primary">
                {loading ? 'Verifying...' : 'Next'}
              </button>
            </form>
          )}

          {mode === 'signup-step4' && (
            <form
              className="auth-card"
              onSubmit={async (e) => {
                e.preventDefault()
                if (password !== confirmPassword) {
                  alert('Passwords do not match')
                  return
                }
                setLoading(true)
                try {
                  const cleanedPhone = phone.replace(/\D/g, '')
                  const identifier =
                    /^\d+$/.test(cleanedPhone) && cleanedPhone.length >= 6
                      ? cleanedPhone
                      : inputValue.trim()
                  const res = await fetch(
                    `${config.backendUrl}/api/auth/create-otp`,
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        email,
                        phone: identifier,
                        username,
                        name,
                        password,
                        confirm_password: confirmPassword,
                      }),
                    }
                  )
                  const data = await res.json()
                  if (res.status === 200) {
                    alert('Account created successfully.')
                    localStorage.setItem('authUser', JSON.stringify(data.user))
                    setMode('signup-step5')
                  } else {
                    alert(data.message || 'Signup failed')
                  }
                } catch (err) {
                  console.error(err)
                  alert('Something went wrong')
                } finally {
                  setLoading(false)
                }
              }}
            >
              <div className="stepper-progress-bar">
                <div className="stepper-fill" style={{ width: '90%' }}></div>
              </div>

              <h2>Create a strong password</h2>
              <p className="subtext">
                Passwords must be a minimum of 6 characters, with an uppercase
                letter and a number.
              </p>

              <div className="input-group">
                <label className="input-label">Password</label>
                <div className="input-with-icon">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    className={`code-input ${
                      isValidPassword(password) ? 'valid' : ''
                    }`}
                  />
                  {isValidPassword(password) && (
                    <span className="tick-icon">✓</span>
                  )}
                </div>
              </div>

              <div className="input-group">
                <label className="input-label">Confirm Password</label>
                <div className="input-with-icon">
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Re-enter password"
                    className={`code-input ${
                      isValidPassword(confirmPassword) &&
                      password === confirmPassword
                        ? 'valid'
                        : ''
                    }`}
                  />
                  {isValidPassword(confirmPassword) &&
                    password === confirmPassword && (
                      <span className="double-tick-icon">
                        <span>✓</span>
                        <span>✓</span>
                      </span>
                    )}
                </div>
              </div>

              <p className="legal-text">
                By creating an account you agree to Vestr’s{' '}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>
                .
              </p>

              <button
                type="submit"
                className="primary"
                disabled={
                  loading ||
                  !isValidPassword(password) ||
                  password !== confirmPassword
                }
              >
                {loading ? 'Creating...' : 'Create account'}
              </button>
            </form>
          )}

          {mode === 'signup-step5' && (
            <div className="auth-card profile-select-step">
              <div className="stepper-progress-bar">
                <div className="stepper-fill" style={{ width: '100%' }}></div>
              </div>

              <h2>Let’s pick a profile picture</h2>
              <p>
                Favorite selfie? Upload it now or create your own from the
                presets.
              </p>

              <div className="profile-preview">
                <div className="preview-circle" style={{ backgroundColor }}>
                  {selectedProfilePicture ? (
                    <img src={selectedProfilePicture} alt="Selected avatar" />
                  ) : (
                    <div className="default-icon" />
                  )}
                </div>
                <button
                  className="upload-btn"
                  onClick={() => document.getElementById('file-input').click()}
                >
                  Upload your own
                </button>
                <input
                  type="file"
                  id="file-input"
                  accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                />
              </div>

              <label className="color-label">Background color:</label>
              <div className="color-picker-container">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={colorSliderValue}
                  onChange={handleColorSlider}
                  className="color-slider"
                />
              </div>

              <div className="preset-section">
                <h4>Animals:</h4>
                <div className="preset-list">
                  {animalAvatars.map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      onClick={() => setSelectedProfilePicture(src)}
                      className={`preset-avatar ${
                        selectedProfilePicture === src ? 'selected' : ''
                      }`}
                    />
                  ))}
                </div>
              </div>

              <div className="preset-section">
                <h4>People:</h4>
                <div className="preset-list">
                  {peopleAvatars.map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      onClick={() => setSelectedProfilePicture(src)}
                      className={`preset-avatar ${
                        selectedProfilePicture === src ? 'selected' : ''
                      }`}
                    />
                  ))}
                </div>
              </div>

              <button
                className="primary"
                disabled={!selectedProfilePicture}
                onClick={handleFinish}
              >
                Finish
              </button>
            </div>
          )}
        </div>
      )}

      {mode === 'forgot-step1' && (
        <form
          className="auth-card"
          onSubmit={async (e) => {
            e.preventDefault()
            setLoading(true)
            try {
              const cleanedPhone = inputValue.replace(/\D/g, '')
              const identifier =
                /^\d+$/.test(cleanedPhone) && cleanedPhone.length >= 6
                  ? cleanedPhone
                  : inputValue.trim()

              const res = await fetch(
                `${config.backendUrl}/api/auth/lookup-user`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ identifier }),
                }
              )
              const data = await res.json()

              if (data.status === 1) {
                setEmail(data.data.actualEmail)
                setPhone(data.data.actualPhone)
                setMode('resetpin-step2')
              } else {
                alert(data.message || 'Account not found')
              }
            } catch (err) {
              console.error('Lookup failed:', err)
              alert('Something went wrong')
            } finally {
              setLoading(false)
            }
          }}
        >
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>
          <h2>Find your Vestr account</h2>
          <p>
            Enter the email, phone number, or username associated with the
            account
          </p>
          <input
            placeholder="Email, phone number, or username"
            value={inputValue}
            onChange={(e) => handleIdentifierChange(e.target.value)}
          />
          <button
            className="primary"
            type="submit"
            disabled={!inputValue.trim() || loading}
          >
            {loading ? 'Looking up...' : 'Next'}
          </button>
        </form>
      )}

      {mode === 'resetpin-step2' && (
        <form
          className="auth-card resetpin-step2"
          onSubmit={async (e) => {
            e.preventDefault()
            setLoading(true)
            try {
              const endpoint =
                selected === 'email'
                  ? '/api/auth/request-otp-email'
                  : '/api/auth/request-otp-phone'

              const payload =
                selected === 'email'
                  ? { email }
                  : { phone: phone.replace(/\D/g, '') }

              const res = await fetch(`${config.backendUrl}${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              })
              const data = await res.json()
              if (data.status === 1) {
                setEmailOtpToken(data.data.token)
                setMode('resetpin-step3')
              } else {
                alert(data.message || 'Failed to send OTP')
              }
            } catch (err) {
              console.error(err)
              alert('Something went wrong')
            } finally {
              setLoading(false)
            }
          }}
        >
          {/* Top bar */}
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>
          <div className="resetpin-options">
            <h2>Where should we send a confirmation code?</h2>
            <p className="subtext">
              Before you can change your password, we need to make sure it’s
              really you.
              <br />
              Start by choosing where to send a confirmation code.
            </p>
            <div className="radio-options-wrapper">
              <label
                className={`radio-option ${
                  selected === 'email' ? 'selected' : ''
                }`}
              >
                <span className="label-text">
                  Send an email to{' '}
                  {email?.replace(/(.{2}).+(@.+)/, '$1*******$2')}
                </span>
                <input
                  type="radio"
                  name="method"
                  value="email"
                  checked={selected === 'email'}
                  onChange={() => {
                    setSelected('email')
                    setOtpMethod('email')
                  }}
                />
                <span className="custom-radio" />
              </label>

              <label
                className={`radio-option ${
                  selected === 'phone' ? 'selected' : ''
                }`}
              >
                <span className="label-text">
                  Text a code to the phone number ending in{' '}
                  {phone?.slice(-2) || '**'}
                </span>
                <input
                  type="radio"
                  name="method"
                  value="phone"
                  checked={selected === 'phone'}
                  onChange={() => {
                    setSelected('phone')
                    setOtpMethod('phone')
                  }}
                />
                <span className="custom-radio" />
              </label>
            </div>

            <p className="support-link">
              Contact <a href="#">Vestr Support</a> if you don’t have access.
            </p>
          </div>

          <button className="primary" type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Next'}
          </button>
        </form>
      )}

      {mode === 'resetpin-step3' && (
        <form
          className="auth-card resetpin-code"
          onSubmit={async (e) => {
            e.preventDefault()
            setLoading(true)
            try {
              const payload =
                otpMethod === 'email'
                  ? { email, otp }
                  : { phone: phone.replace(/\D/g, ''), otp }

              const res = await fetch(
                `${config.backendUrl}/api/auth/verify-otp-${otpMethod}`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload),
                }
              )

              const data = await res.json()
              if (res.ok && data.status === 1) {
                setEmailOtpToken(data.data.token)
                setMode('resetpin-step4')
              } else {
                alert(data.message || 'Invalid or expired OTP')
              }
            } catch (err) {
              alert('Something went wrong')
            } finally {
              setLoading(false)
            }
          }}
        >
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>
          <h2>We sent you a code</h2>
          <p className="subtext">
            Check your phone to get your confirmation code. If you need to
            request a new code, go back and reselect a confirmation method.
          </p>

          <label className="input-label">Enter your code</label>
          <input
            placeholder="Enter code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="code-input"
          />

          <div className="bottom-bar">
            <button
              type="button"
              className="text-button"
              onClick={() => setMode('resetpin-step2')}
            >
              Back
            </button>
            <button className="next-button" type="submit" disabled={loading}>
              {loading ? 'Verifying...' : 'Next'}
            </button>
          </div>
        </form>
      )}

      {mode === 'resetpin-step4' && (
        <form
          className="auth-card"
          onSubmit={async (e) => {
            e.preventDefault()

            if (password !== confirmPassword) {
              alert('Passwords do not match')
              return
            }
            setLoading(true)
            try {
              const res = await fetch(
                `${config.backendUrl}/api/auth/reset-pin-otp-email`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    token: emailOtpToken,
                    otp,
                    pin: password,
                    confirm_pin: confirmPassword,
                  }),
                }
              )

              const data = await res.json()
              if (data.status === 1) {
                alert('Password successfully updated.')
                setMode('signin-step1')
              } else {
                alert(data.message || 'Failed to reset PIN')
              }
            } catch (err) {
              console.error(err)
              alert('Something went wrong')
            } finally {
              setLoading(false)
            }
          }}
        >
          <div className="top-bar">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => setMode('intro')}
            >
              Cancel
            </button>
            <div className="signin-logo-mobile">
              <img
                src={dk() ? vestrLogo1dark : vestrLogo1light}
                alt="vestr logo"
              />
            </div>
          </div>
          <h2>Create a strong password</h2>
          <p className="subtext">
            Passwords must be a minimum of 6 characters, with an uppercase
            letter and a number.
          </p>

          <div className="input-group">
            <label className="input-label">Password</label>
            <div className="input-with-icon">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className={`code-input ${
                  isValidPassword(password) ? 'valid' : ''
                }`}
              />
              {isValidPassword(password) && (
                <span className="tick-icon">✓</span>
              )}
            </div>
          </div>

          <div className="input-group">
            <label className="input-label">Confirm Password</label>
            <div className="input-with-icon">
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Re-enter password"
                className={`code-input ${
                  isValidPassword(confirmPassword) &&
                  password === confirmPassword
                    ? 'valid'
                    : ''
                }`}
              />
              {isValidPassword(confirmPassword) &&
                password === confirmPassword && (
                  <span className="double-tick-icon">
                    <span>✓</span>
                    <span>✓</span>
                  </span>
                )}
            </div>
          </div>
          <p className="legal-text">
            By creating an account you agree to Vestr’s{' '}
            <a href="/privacy" target="_blank">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href="/terms" target="_blank">
              Terms of Service
            </a>
            .
          </p>

          <button
            type="submit"
            className="change-password-button"
            disabled={
              loading ||
              !isValidPassword(password) ||
              password !== confirmPassword
            }
          >
            {loading ? 'Saving...' : 'Change Password'}
          </button>
        </form>
      )}

      {/* Onboarding flows remain unchanged */}
      {mode === 'onboarding1' && (
        <div className="auth-card wide">
          <h2>Invest with the best</h2>
          <p>Follow one or more accounts</p>
          {accounts.map((a) => (
            <div key={a.id} className="card">
              <div className="card-info">
                <img className="avatar" src={a.avatar} alt="" />
                <div>
                  <strong>
                    {a.name} {a.verified && '✔'}
                  </strong>
                  <div>@{a.handle}</div>
                  <div className="stat">▲ {a.return}% all time</div>
                  <p>{a.desc}</p>
                </div>
              </div>
              <button
                className={a.following ? 'following' : 'follow'}
                onClick={() => toggleFollow(a.id)}
              >
                {a.following ? 'Following' : 'Follow'}
              </button>
            </div>
          ))}
          <button className="primary" onClick={handleNextOnboarding}>
            Next
          </button>
        </div>
      )}
      {mode === 'onboarding2' && (
        <div className="auth-card wide">
          <h2>Don’t miss out</h2>
          <p>Join one or more groups</p>
          {groups.map((g) => (
            <div key={g.id} className="card">
              <div className="card-info">
                <img className="avatar" src={g.avatar} alt="" />
                <div>
                  <strong>
                    {g.name} {g.verified && '✔'}
                  </strong>
                  <div>{g.members} members</div>
                  <p>{g.desc}</p>
                </div>
              </div>
              <button
                className={g.joined ? 'following' : 'follow'}
                onClick={() => toggleJoin(g.id)}
              >
                {g.joined ? 'Joined' : 'Join'}
              </button>
            </div>
          ))}
          <button className="primary" onClick={handleNextOnboarding}>
            Next
          </button>
        </div>
      )}
      {mode === 'onboarding3' && (
        <div className="auth-card wide">
          <h2>Last step! Add to watchlist</h2>
          {watchlist.map((w) => (
            <div key={w.id} className="card">
              <div className="card-info">
                <div>
                  <strong>{w.symbol}</strong>
                  <div>{w.company}</div>
                </div>
                <div className="price">
                  ${w.price} ▲ {w.change}%
                </div>
              </div>
              <button
                className={w.added ? 'following' : 'follow'}
                onClick={() => toggleWatch(w.id)}
              >
                {w.added ? '✓' : '+'}
              </button>
            </div>
          ))}
          <button className="primary" onClick={handleNextOnboarding}>
            Finish!
          </button>
        </div>
      )}
    </div>
  )
}
